import { render, staticRenderFns } from "./LocationAdditionalCharge.vue?vue&type=template&id=315abdda&"
import script from "./LocationAdditionalCharge.vue?vue&type=script&lang=js&"
export * from "./LocationAdditionalCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports